import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-556eeb14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "翼辉产品授权激活系统", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bgimg" })
], -1))
const _hoisted_4 = { class: "texts" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "lic" }
const _hoisted_7 = { class: "btns" }

import { onMounted } from "vue";
import { reactive } from 'vue';
import { useRouter } from 'vue-router';
import useClipboard from 'vue-clipboard3';

export default /*#__PURE__*/_defineComponent({
  __name: 'AcoView',
  setup(__props) {

let baseURL:string;
let route = useRouter()
if (process.env.VUE_APP_FLAG == "development") {
  baseURL = "http://localhost:8082/";
} else if (process.env.VUE_APP_FLAG == "production") {
  baseURL = "api/";
}

const { toClipboard } = useClipboard()
const copy = async (val: string) => {
  try {
    await toClipboard(val)
  } catch (e) {
    return { copy }
  }
}

const data = reactive({
        regcode: route.currentRoute.value.params.id,
        Info: "",
        SN: "",
        Lic: "",
})

onMounted(() => {
  if(route.currentRoute.value.params.id != undefined) {
    getLic();
  }
});

function getLic() {
if(data.regcode == undefined){
  var id = route.currentRoute.value.params.id;
} else {
  id = data.regcode;
}
fetch((baseURL + "acolinux/licsrv/"), {
  method: "post",
  body: JSON.stringify({
    RegCode: id ,
  }),
  headers: {
    "Content-Type": "application/json",
  },
})
  .then((res) => {
    return res.json();
  })
  .then((res) => {
    if(res.ErrString == "Clear"){
      data.Info = "License:";
      data.SN = "SN: " + res.SN;
      data.Lic = res.Lic;
    } else if (res.ErrString == "WRONG SN") {
      data.Info = "Warning:";
      data.SN = "Wrong SN Code";
      data.Lic = "Wrong SN Code";
    } else if (res.ErrString == "SN USED") {
      data.Info = "Warning:";
      data.SN = "This SN is USED";
      data.Lic = "This SN is USED";
    } else if (res.ErrString == "Empty Code") {
      data.Info = "QrCode Warning:";
      data.SN = "Try to Scan again";
      data.Lic = "Try to Scan again";
    } else if (res.ErrString == "Wrong Format") {
      data.Info = "QrCode Warning:";
      data.SN = "Try to Scan again";
      data.Lic = "Try to Scan again";
    } else if (res.ErrString == "SN EXPIRE") {
      data.Info = "Warning:";
      data.SN = "This SN is expire you may need to contact sales";
      data.Lic = "This SN is expire you may need to contact sales";
    } else if (res.ErrString == "BSP UID NOT MATCH") {
      data.Info = "Warning:";
      data.SN = "BSP UID is not match";
      data.Lic = "BSP UID is not match";
    } else {
      data.Info = "Service Error Warning:";
      data.SN = "Wait 1 min Before Try again";
      data.Lic = "Wait 1 min Before Try again";
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, " AcoSail " + _toDisplayString(data.Info), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(data.Lic), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (copy(data.Lic)))
      }, "Copy"),
      _createElementVNode("button", {
        class: "copybtn",
        onClick: getLic
      }, "Retry")
    ])
  ]))
}
}

})